import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export const useHomeownerTranslate = () =>
  useTranslate(TranslationNamespace.HOMEOWNER_APP);
